import React from "react";
import { Link } from "react-router-dom";
import { Crown } from "lucide-react";
import { GAMES } from "@/lib/content";
import { useSub } from "@/lib/subscription";
import { isFreeGame } from "@/lib/gating";
import { LockBadge } from "@/components/UpgradeGate";

const tileBg = { yellow: "bg-amber-100 border-amber-300", blue: "bg-sky-100 border-sky-300", green: "bg-emerald-100 border-emerald-300", pink: "bg-pink-100 border-pink-300", purple: "bg-violet-100 border-violet-300", orange: "bg-orange-100 border-orange-300", sky: "bg-cyan-100 border-cyan-300" };

export default function Play() {
  const { premium } = useSub();
  return (
    <div className="ll-bg min-h-screen pb-28 md:pb-8">
      <main className="max-w-6xl mx-auto px-4 sm:px-6 pt-6">
        <div className="text-center pt-4">
          <div className="text-purple-500 uppercase tracking-widest text-xs font-bold">Playground</div>
          <h1 className="font-display font-bold text-4xl sm:text-5xl text-purple-900 mt-1">Let's play a game!</h1>
          <p className="text-purple-700/70 font-semibold mt-2">Little brain workouts, big smiles.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-8">
          {GAMES.map(g => {
            const locked = !premium && !isFreeGame(g.id);
            const Wrapper = locked ? "div" : Link;
            const wrapProps = locked ? {} : { to: g.path };
            return (
              <Wrapper key={g.id} {...wrapProps} data-testid={`game-card-${g.id}`} className={`relative ll-tile ${tileBg[g.color] || tileBg.purple} ${locked ? "cursor-default" : ""}`}>
                {locked && <LockBadge className="absolute top-3 right-3" />}
                {!premium && isFreeGame(g.id) && <span className="absolute top-3 right-3 bg-emerald-500 text-white text-[11px] font-bold px-2.5 py-1 rounded-full shadow" data-testid={`free-game-badge-${g.id}`}>Free</span>}
                <div className="flex items-center gap-4">
                  <div className="w-20 h-20 rounded-2xl bg-white/80 flex items-center justify-center text-5xl overflow-hidden shrink-0">
                    {g.image ? <img src={g.image} alt="" className="w-full h-full object-contain p-1" onError={(e) => { e.currentTarget.replaceWith(Object.assign(document.createElement("div"), { textContent: g.emoji, className: "text-5xl" })); }} /> : g.emoji}
                  </div>
                  <div className="flex-1">
                    <div className="font-display font-bold text-2xl text-purple-900">{g.title}</div>
                    <div className="text-purple-700/80 text-sm font-semibold">{g.desc}</div>
                  </div>
                </div>
                {locked ? (
                  <Link to="/pricing" data-testid={`unlock-game-${g.id}`} className="ll-btn w-full mt-4 bg-yellow-300 text-purple-900 shadow-[0_6px_0_0_#CA8A04]"><Crown size={18} /> Unlock with Premium</Link>
                ) : (
                  <span data-testid={`play-game-${g.id}`} className="ll-btn ll-btn-primary w-full mt-4 block text-center">Play →</span>
                )}
              </Wrapper>
            );
          })}
        </div>
      </main>
    </div>
  );
}
